// Module
var code = `<!-- 9. Dot and bar -->
<div class="jumbotron-surface style-guide-section">
  <div class="jumbotron-panel-head style-guide-section-head">
    <span class="jumbotron-heading">Dot and bar</span>
    <span class="jumbotron-note">The colour of a dot comes from the data. The code sets the width of a fill.</span>
  </div>
  <div class="style-guide-body">
    <div class="style-guide-row-samples">
      <div class="style-guide-sample">
        <span class="style-guide-dots">
          <span class="jumbotron-dot style-guide-dot" ng-repeat="colour in \$ctrl.sampleColours track by colour"
            ng-style="{ 'background-color': colour }"></span>
        </span>
        <code class="style-guide-caption">.jumbotron-dot</code>
      </div>
      <div class="style-guide-sample">
        <span class="style-guide-dots">
          <span class="jumbotron-dot-big style-guide-dot-big" ng-repeat="colour in \$ctrl.sampleColours track by colour"
            ng-style="{ 'background-color': colour }"></span>
        </span>
        <code class="style-guide-caption">.jumbotron-dot-big</code>
      </div>
      <div class="style-guide-sample">
        <span class="style-guide-bars">
          <span class="jumbotron-bar-track style-guide-bar" ng-repeat="share in \$ctrl.sampleShares track by share">
            <span class="jumbotron-bar-fill style-guide-bar-fill" ng-style="{ width: share + '%' }"></span>
          </span>
        </span>
        <code class="style-guide-caption">.jumbotron-bar-track &middot; .jumbotron-bar-fill</code>
      </div>
    </div>
  </div>
</div>

<!-- 10. Notes and tints -->
<div class="jumbotron-surface style-guide-section">
  <div class="jumbotron-panel-head style-guide-section-head">
    <span class="jumbotron-heading">Notes and tints</span>
    <span class="jumbotron-note">There are three conditions and no more. A page must not write a fourth pair. The alert banner of the app reads the same tokens.</span>
  </div>
  <div class="style-guide-body">
    <div class="style-guide-grid">
      <div class="style-guide-sample">
        <span class="jumbotron-note">The plan is saved.</span>
        <code class="style-guide-caption">.jumbotron-note</code>
      </div>
      <div class="style-guide-sample">
        <span class="jumbotron-note-box is-ok">Every scene has a playlist for the day.</span>
        <code class="style-guide-caption">.jumbotron-note-box &middot; .is-ok</code>
      </div>
      <div class="style-guide-sample">
        <span class="jumbotron-note-box is-warn">Two intervals have the same priority.</span>
        <code class="style-guide-caption">.jumbotron-note-box &middot; .is-warn</code>
      </div>
      <div class="style-guide-sample">
        <span class="jumbotron-note-box is-bad">The scene lost contact 12 minutes ago.</span>
        <code class="style-guide-caption">.jumbotron-note-box &middot; .is-bad</code>
      </div>
      <div class="style-guide-sample">
        <div class="alert alert-warning py-2 mb-0" role="alert">
          <i class="fa fa-triangle-exclamation" aria-hidden="true"></i>
          <span>The server is slow to answer.</span>
        </div>
        <code class="style-guide-caption">alert alert-warning</code>
      </div>
      <div class="style-guide-sample">
        <div class="alert alert-danger py-2 mb-0" role="alert">
          <i class="fa fa-circle-exclamation" aria-hidden="true"></i>
          <span>Lost the connection to the server.</span>
        </div>
        <code class="style-guide-caption">alert alert-danger</code>
      </div>
    </div>
  </div>
</div>

<!-- 11. Selection -->
<div class="jumbotron-surface style-guide-section">
  <div class="jumbotron-panel-head style-guide-section-head">
    <span class="jumbotron-heading">Selection</span>
    <span class="jumbotron-note">A selection is blue: the object the operator picked. A live state is a green mark: the clip on the screen now. The two never meet on one row.</span>
  </div>
  <div class="style-guide-body">
    <div class="style-guide-row-samples">
      <div class="style-guide-sample">
        <span class="jumbotron-chip style-guide-chip">Thursday</span>
        <code class="style-guide-caption">.jumbotron-chip</code>
      </div>
      <div class="style-guide-sample">
        <span class="jumbotron-chip jumbotron-selected style-guide-chip">Friday</span>
        <code class="style-guide-caption">.jumbotron-chip &middot; .jumbotron-selected</code>
      </div>
      <div class="style-guide-sample">
        <span class="style-guide-list-row">
          <span>Merch</span>
          <span class="style-guide-num">00:20</span>
        </span>
        <code class="style-guide-caption">.style-guide-list-row</code>
      </div>
      <div class="style-guide-sample">
        <span class="jumbotron-selected style-guide-list-row">
          <span>TZ_Friday</span>
          <span class="style-guide-num">00:55</span>
        </span>
        <code class="style-guide-caption">.jumbotron-selected</code>
      </div>
      <div class="style-guide-sample">
        <span class="style-guide-list-row">
          <span><i class="jumbotron-live-mark fas fa-play style-guide-live" aria-hidden="true"></i> Silent_spot</span>
          <span class="style-guide-num">10:39:20</span>
        </span>
        <code class="style-guide-caption">.jumbotron-live-mark</code>
      </div>
    </div>
  </div>
</div>
`;
// Exports
export default code;